import React, {
    useContext,
    useState,
    useMemo,
} from 'react';
import { useQuery } from '@tanstack/react-query';


import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";
import { getBasketData } from "../router";

import BasketTicketItem from './basket-ticket-item';
import LoadingIndicator from '../components/loading-indicator';
import Logo from '../svg/logo';
import MultibuyIcon from '../svg/multibuy';

export default function BasketEvent (props) {

    const { data: basketData } = getBasketData();

    const multibuyCount = useMemo(() => {
        if (!basketData?.tickets) return 0;
        const instanceIds = new Set();
        basketData.tickets.forEach(ticket => {
            const event = ticket.event?.name ? ticket.event : ticket.instance?.event;
            if (event?.attribute_MultiBuy) {
                instanceIds.add(ticket.instance?.id);
            }
        });
        return instanceIds.size;
    }, [basketData]);

    const isMultibuyEvent = useMemo(() => {
        if (!props.event.tickets?.length) return false;
        const ticket = props.event.tickets[0];
        const event = ticket.event?.name ? ticket.event : ticket.instance?.event;
        return !!event?.attribute_MultiBuy;
    }, [props.event.tickets]);

    const {
        isPending,
        isFetching,
        data: imageData,
    } = useQuery({
        queryKey: ['imageData', props.event.event_id],
        queryFn: () => QUERIES.getEventImage(props.event.event_id),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000
    });

    return (
        <div className='basket-item'>
            <div className='basket-item__image'>
                {isPending || isFetching ?
                    <LoadingIndicator />
                : imageData ?
                    <div className='basket-item__image--wp' dangerouslySetInnerHTML={{__html: imageData}}></div>
                : props.event.event_image ?
                    <img src={props.event.event_image } className='basket-item__image--spektrix' />
                :
                    <Logo />
                }
            </div>
            <div className='basket-item__summary instance-event-summary'>
                <h2 className='basket-item__title instance-event-summary__title'>{props.event.event_name}</h2>


                <div className='basket-item__flex'>
                    <div>
                        <p className='basket-item__date instance-event-summary__date'>{props.event.instance_date}</p>
                        <p className='basket-item__venue instance-event-summary__venue'>{props.event.event_venue}</p>
                    </div>

                    {isMultibuyEvent && (
                        multibuyCount >= 3 ? (
                            <div className='basket-item__flex__button applied'>
                                <MultibuyIcon />
                                Multibuy applied
                            </div>
                        ) : (
                            <div className='basket-item__flex__button offer'>
                                <MultibuyIcon />
                                Multibuy eligible
                            </div>
                        )
                    )}
                </div>
            </div>
            <ul className='basket-item__ticket-list' role="list">
                {props.event.tickets?.map((ticket) => (
                    <BasketTicketItem key={ticket.id} ticket={ticket} />
                ))}
            </ul>
        </div>
    )
}